"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "isBrowser", {
  enumerable: true,
  get: function get() {
    return _misc.isBrowser;
  }
});
Object.defineProperty(exports, "isServer", {
  enumerable: true,
  get: function get() {
    return _misc.isServer;
  }
});
Object.defineProperty(exports, "isString", {
  enumerable: true,
  get: function get() {
    return _misc.isString;
  }
});
Object.defineProperty(exports, "isBoolean", {
  enumerable: true,
  get: function get() {
    return _misc.isBoolean;
  }
});
Object.defineProperty(exports, "appendQueryParams", {
  enumerable: true,
  get: function get() {
    return _misc.appendQueryParams;
  }
});
Object.defineProperty(exports, "identity", {
  enumerable: true,
  get: function get() {
    return _misc.identity;
  }
});
Object.defineProperty(exports, "isUrlExternal", {
  enumerable: true,
  get: function get() {
    return _misc.isUrlExternal;
  }
});
Object.defineProperty(exports, "browserVersion", {
  enumerable: true,
  get: function get() {
    return _Browser.browserVersion;
  }
});
Object.defineProperty(exports, "isSafari", {
  enumerable: true,
  get: function get() {
    return _Browser.isSafari;
  }
});
Object.defineProperty(exports, "isMobileApple", {
  enumerable: true,
  get: function get() {
    return _Browser.isMobileApple;
  }
});
Object.defineProperty(exports, "isTouchScreenDevice", {
  enumerable: true,
  get: function get() {
    return _Browser.isTouchScreenDevice;
  }
});
Object.defineProperty(exports, "isUserAgentBot", {
  enumerable: true,
  get: function get() {
    return _Browser.isUserAgentBot;
  }
});
Object.defineProperty(exports, "detectDevice", {
  enumerable: true,
  get: function get() {
    return _Browser.detectDevice;
  }
});
Object.defineProperty(exports, "isSupported", {
  enumerable: true,
  get: function get() {
    return _Browser.isSupported;
  }
});
Object.defineProperty(exports, "safeAction", {
  enumerable: true,
  get: function get() {
    return _Browser.safeAction;
  }
});
Object.defineProperty(exports, "ifBrowserThen", {
  enumerable: true,
  get: function get() {
    return _Browser.ifBrowserThen;
  }
});

var _misc = require("../misc");

var _Browser = require("../Browser");